import React, {lazy, Suspense} from 'react'
import {createBrowserRouter, useMatches} from "react-router-dom";

//import Index from "../pages";
import {LayoutBM} from "../dist/Layout";
import EmployeeTab from "../pages/Employee/EmployeeTab";
import EmployeeAdd from "../pages/Employee/EmployeeAdd";

import RoleTab from "../pages/Role/RoleTab";
import RoleAdd from "../pages/Role/RoleAdd";
import AccessMenu from "../pages/Role/AccessMenu";
import SmetaTab from "../pages/Smeta/SmetaTab/SmetaTab";
import SmetaOldTab from "../pages/Smeta/SmetaOldTab/SmetaOldTab";
import SmetaAdd from "../pages/Smeta/SmetaAdd";
import SmetaAcc from "../pages/Smeta/SmetaAcc";


import TEST from "../pages/Smeta/TEST";
import NotFoundNew from "./NotFoundNew";
import CardRegistryTab from "../pages/Bank/CardRegistry/CardRegistryTab.jsx";
import RequireAuth from "../components/RequireAuth";
import HomeNew from "../dist/Home1";

const IndexHB = lazy(() => import('../pages/indexHB'));
const AccessRole = lazy(() => import('../pages/Employee/AccessRole'));
const EmployeeEdit = lazy(() => import('../pages/Employee/EmployeeEdit'));
const CitizenHistory = lazy(() => import('../pages/Employee/CitizenHistory'));
const AccountAdd = lazy(() => import('../pages/Account/AccountAdd'));
const AccountTab = lazy(() => import('../pages/Account/AccountTab'));
const AccessDocAction = lazy(() => import('../pages/Role/AccessDocAction'));
const BankInfoTab = lazy(() => import('../pages/Bank/BankInfoTab'));
const BankAccSaldoTab = lazy(() => import('../pages/Bank/BankAccSaldoTab'));
const BankUsers = lazy(() => import('../pages/Bank/BankUsers'));
const BankCardsTab = lazy(() => import('../pages/Bank/BankCardsTab'));
const AccSaldoByBankTab = lazy(() => import('../pages/Report/AccountSaldo/ByBankTab'));
const PaydocAdd = lazy(() => import('../pages/Paydoc/PaydocAdd'));
const PaydocReturnAdd = lazy(() => import('../pages/Paydoc/PaydocReturnAdd'));
const PaydocEdit = lazy(() => import('../pages/Paydoc/PaydocEdit'));
const PaydocBankEdit = lazy(() => import('../pages/Paydoc/PaydocBankEdit'));
const PaydocRecoveryAdd = lazy(() => import('../pages/Paydoc/PaydocRecoveryAdd'));
const PaydocTab = lazy(() => import('../pages/Paydoc/PaydocTab'));
const PaydocOldTab = lazy(() => import('../pages/Paydoc/PaydocOldTab'));
const BudgetPaydocTab = lazy(() => import('../pages/Budget/Paydoc/BudgetPaydocTab'));
const BridgeOutTab = lazy(() => import('../pages/Document/Bridge/BridgeOutTab'));
const SmetaAccView = lazy(() => import('../pages/Smeta/SmetaAccView'));
const SmetaAccNew = lazy(() => import('../pages/Smeta/SmetaAccNew'));
const SmetaCreate = lazy(() => import('../pages/Smeta/SmetaCreate'));
const ContractAdd = lazy(() => import('../pages/Contract/ContractAdd'));
const ContractEdit = lazy(() => import('../pages/Contract/ContractEdit'));
const ContractTab = lazy(() => import('../pages/Contract/ContractTab'));
const ContractOldTab = lazy(() => import('../pages/Contract/ContractOldTab'));
const CashAppAdd = lazy(() => import('../pages/CashApp/CashAppAdd'));
const CashAppTab = lazy(() => import('../pages/CashApp/CashAppTab'));
const CashAppEdit = lazy(() => import('../pages/CashApp/CashAppEdit'));
const VendorAdd = lazy(() => import('../pages/Vendor/VendorAdd'));
const VendorEdit = lazy(() => import('../pages/Vendor/VendorEdit'));
const VendorTab = lazy(() => import('../pages/Vendor/VendorTab'));
const InvoiceAdd = lazy(() => import('../pages/Invoice/InvoiceAdd'));
const InvoiceTab = lazy(() => import('../pages/Invoice/InvoiceTab'));
const InvoiceEdit = lazy(() => import('../pages/Invoice/InvoiceEdit'));

const AccountStateTab = lazy(() => import('../pages/AccountState/AccountStateTab/AccountStateTab'));
const AccSaldoPeriodTab = lazy(() => import('../pages/AccountState/AccSaldoPeriodTab'));
const AccountMonitoringTab = lazy(() => import('../pages/AccountState/AccountMonitoringTab'));
const SmetaExecuteTab = lazy(() => import('../pages/AccountState/SmetaExecuteTab'));

const BankAccSaldoPeriodTab = lazy(() => import('../pages/Account/BankAccSaldoPeriodTab'));
const BankAccExpensePeriodTab = lazy(() => import('../pages/Account/BankAccExpensePeriod/BankAccExpensePeriodTab'));
const ContractExecuteTab = lazy(() => import('../pages/Report/ContractExecute/ContractExecuteTab'));
const CashAppExecuteTab = lazy(() => import('../pages/Report/CashAppExecute/CashAppExecuteTab'));
const DocumentControlsTab = lazy(() => import('../pages/Document/DocumentControls/DocumentControlsTab/DocumentControlsTab'));
const DocumentControlsCreate = lazy(() => import('../pages/Document/DocumentControls/DocumentControlsCreate/DocumentControlsCreate'));
const DidoxDocumentsTab = lazy(() => import('../pages/Document/Didox/DidoxDocumentsTab/DidoxDocumentsTab'));
const DidoxDocumentsAdd = lazy(() => import('../pages/Document/Didox/DidoxDocumentsAdd/DidoxDocumentsAdd'));
const DidoxDocumentsAct = lazy(() => import('../pages/Document/Didox/DidoxDocumentsByEmpIdTab/DidoxDocumentsAct'));
const DidoxProductsTab = lazy(() => import('../pages/Report/DidoxDocument/ProductsTab'));
const DidoxDocumentsByEmpIdTab = lazy(() => import('../pages/Document/Didox/DidoxDocumentsByEmpIdTab/DidoxDocumentsByEmpIdTab'));
const DidoxInvoice = lazy(() => import('../pages/Document/Didox/DidoxInvoice/DidoxInvoice'));
const DidoxContractAdd = lazy(() => import('../pages/Document/Didox/DidoxContract/DidoxContractAdd'));
const DidoxUsersTab = lazy(() => import('../pages/Document/Didox/DidoxUser/DidoxUsersTab'));
const ProcurementTab = lazy(() => import('../pages/Procurement/ProcurementTab'));
const ProcurementAdd = lazy(() => import('../pages/Procurement/ProcurementAdd'));
const ProcurementCreate = lazy(() => import('../pages/Procurement/ProcurementCreate/ProcurementForm'));
const InmatesTab = lazy(() => import('../pages/Inmates/InmatesTab'));
const InmatesSaldoTab = lazy(() => import('../pages/Inmates/InmatesSaldoTab'));
const ReferencesTab = lazy(() => import('../pages/Reference/ReferencesTab'));
const RefExpenseTab = lazy(() => import('../pages/Reference/RefExpenseTab'));
const RefAccountTypeTab = lazy(() => import('../pages/Reference/RefAccountTypeTab'));
const RefBankTypeTab = lazy(() => import('../pages/Reference/RefBankTypeTab'));
const RefBankTab = lazy(() => import('../pages/Reference/RefBankTab'));
const RefFilialTab = lazy(() => import('../pages/Reference/RefFilialTab'));
const RefPaydocTypeTab = lazy(() => import('../pages/Reference/RefPaydocTypeTab'));
const RefSmetaTypeTab = lazy(() => import('../pages/Reference/RefSmetaTypeTab'));
const RefRegionTab = lazy(() => import('../pages/Reference/RefRegionTab'));
const RefTerritoryTab = lazy(() => import('../pages/Reference/RefTerritoryTab'));
const RefGoodTab = lazy(() => import('../pages/Reference/RefGoodTab'));
const RefGoodMhikTab = lazy(() => import('../pages/Reference/RefGoodMhikTab/RefGoodMhikTab'));
const RefGoodAdd = lazy(() => import('../pages/Reference/RefGoodAdd'));
const RefFilialAdd = lazy(() => import('../pages/Reference/RefFilialAdd'));
const RefExpenseCategoryTab = lazy(() => import('../pages/Reference/RefExpenseCategory/./ExpenseCategoryTab'));
const RefExpenseCategoryForm = lazy(() => import('../pages/Reference/RefExpenseCategory/AddExpenseCategory'));
const TradeExchangeDocumentsTab = lazy(() => import('../pages/Market/TradeExchangeDocsTab'));

const MunisPay = lazy(() => import('../pages/Employee/MunisPay'));


function RouteComponent() {
    const matches = useMatches();
    const current = matches[matches.length - 1];
    if (!current) return null;
    const { refType, refTitle } = current.handle || {};

    return <ReferencesTab refType={refType} refTitle={refTitle} />;
}

function ErrorPage() {
    return <div>Router error</div>
}

export const mainRoutes = createBrowserRouter([
    {

        path: "/", element: <IndexHB/>, errorElement: <ErrorPage />

    },
    {
        element: <RequireAuth/>,
        children: [
            {
                path: "/layout",
                element: <LayoutBM/>,
                children: [
                    {index: true, element: <HomeNew/>, handle: {titleKey: "homeWindow"}},
                    //{index: true, element: <DashboardPage/>, handle: {titleKey: "homeWindow"}},
                    {path: "accountTab", element: <AccountTab/>, handle: {titleKey: "accountTab"}},
                    {path: "accountAdd", element: <AccountAdd/>},
                    {path: "employeeEdit/:id", element: <EmployeeEdit/>, handle: {titleKey: "employeeEdit/:id"}},
                    {path: "employeeTab", element: <EmployeeTab/>, handle: {titleKey: "employeeTab"}},
                    {path: "employeeAdd", element: <EmployeeAdd/>},
                    {path: "refTabAccount", element: <RouteComponent/>, handle: {titleKey: "refTabAccount", "refType": "account"}},
                    {path: "refTabExpense", element: <RouteComponent/>, handle: {titleKey: "refTabExpense", "refType": "expense"}},
                    {path: "refExpenseCategoryTab", element: <RefExpenseCategoryTab/>, handle: {titleKey: "refExpenseTab"}},
                    {path: "refExpenseCategoryForm", element: <RefExpenseCategoryForm/>, handle: {titleKey: "refExpenseCategoryForm"}},
                    {path: "refAccountTypeTab", element: <RefAccountTypeTab/>, handle: {titleKey: "refAccountTypeTab"}},
                    {path: "refBankTab", element: <RefBankTab/>, handle: {titleKey: "refBankTab"}},
                    {path: "refBankTypeTab", element: <RefBankTypeTab/>, handle: {titleKey: "refBankTypeTab"}},
                    {path: "refFilialTab", element: <RefFilialTab/>, handle: {titleKey: "refFilialTab"}},
                    {path: "refFilialAdd", element: <RefFilialAdd/>, handle: {titleKey: "refFilialAdd"}},
                    {path: "refExpenseTab", element: <RefExpenseTab/>, handle: {titleKey: "refExpenseTab"}},
                    {path: "refPaydocTypeTab", element: <RefPaydocTypeTab/>, handle: {titleKey: "refPaydocTypeTab"}},
                    {path: "refSmetaTypeTab", element: <RefSmetaTypeTab/>, handle: {titleKey: "refSmetaTypeTab"}},
                    {path: "refRegionTab", element: <RefRegionTab/>, handle: {titleKey: "refRegionTab"}},
                    {path: "refTerritoryTab", element: <RefTerritoryTab/>, handle: {titleKey: "refTerritoryTab"}},
                    {path: "refGoodTab", element: <RefGoodTab/>, handle: {titleKey: "refGoodTab"}},
                    {path: "refGoodMhikTab", element: <RefGoodMhikTab/>, handle: {titleKey: "refGoodMhikTab"}},
                    {path: "refGoodAdd", element: <RefGoodAdd/>},
                    {path: "roleTab", element: <RoleTab/>, handle: {titleKey: "roleTab"}},
                    {path: "roleAdd", element: <RoleAdd/>},
                    {path: "accessMenu", element: <AccessMenu/>},
                    {path: "bankInfoTab", element: <BankInfoTab/>, handle: {titleKey: "bankInfoTab"}},
                    {path: "bankAccSaldoTab", element: <BankAccSaldoTab/>, handle: {titleKey: "bankAccSaldoTab"}},
                    {path: "accountSaldoByBankTab", element: <AccSaldoByBankTab/>, handle: {titleKey: "accountSaldoByBankTab"}},
                    {path: "smetaTab", element: <SmetaTab/>, handle: {titleKey: "smetaTab"}},
                    {path: "smetaOldTab", element: <SmetaOldTab/>, handle: {titleKey: "smetaOldTab"}},
                    {path: "bankAccSaldoPeriodTab", element: <BankAccSaldoPeriodTab/>, handle: {titleKey: "bankAccSaldoPeriodTab"}},
                    {path: "bankAccExpensePeriodTab", element: <BankAccExpensePeriodTab/>, handle: {titleKey: "bankAccExpensePeriodTab"}},
                    {path: "bankUsers", element: <BankUsers/>, handle: {titleKey: "bankUsers"}},
                    {path: "bankCardsTab", element: <BankCardsTab/>, handle: {titleKey: "bankCardsTab"}},
                    {path: "registerBankCards", element: <CardRegistryTab/>, handle: {titleKey: "registerBankCards"}},
                    {path: "smetaAdd", element: <SmetaAdd/>},
                    {path: "smetaAcc", element: <SmetaAcc/>},
                    {path: "smetaCreate", element: <SmetaCreate/>},
                    {path: "documentControlsCreate", element: <DocumentControlsCreate/>},
                    {path: "didoxDocumentsTab", element: <DidoxDocumentsTab/>, handle: {titleKey: "didoxDocumentsTab"}},
                    {path: "didoxDocumentsAdd", element: <DidoxDocumentsAdd/>},
                    {path: "didoxDocumentsAct", element: <DidoxDocumentsAct/>},
                    {path: "didoxDocumentsSavedTab", element: <DidoxDocumentsByEmpIdTab/>, handle: {titleKey: "didoxDocumentsSavedTab"}},
                    {path: "paydocTab", element: <PaydocTab/>, handle: {titleKey: "paydocTab"}},
                    {path: "paydocOldTab", element: <PaydocOldTab/>, handle: {titleKey: "paydocOldTab"}},
                    {path: "paydocAdd", element: <PaydocAdd/>},
                    {path: "paydocReturnAdd", element: <PaydocReturnAdd/>, handle: {titleKey: "paydocReturnAdd"}},
                    {path: "paydocTab/edit/:id", element: <PaydocEdit/>},
                    {path: "paydocTab/editBank/:id/:paydocState", element: <PaydocBankEdit/>},
                    {path: "paydocTab/editBankRecovery/:id/:paydocState", element: <PaydocRecoveryAdd/>},
                    {path: "paydocOldTab/editBankRecovery/:id/:paydocState", element: <PaydocRecoveryAdd/>},
                    {path: "paydocOldTab/edit/:id", element: <PaydocEdit/>},
                    {path: "budgetPaydocTab", element: <BudgetPaydocTab/>, handle: {titleKey: "budgetPaydocTab"}},
                    {path: "bridgeOutTab", element: <BridgeOutTab/>, handle: {titleKey: "bridgeOutTab"}},
                    {path: "SmetaAccView", element: <SmetaAccView/>, handle: {titleKey: "SmetaAccView"}},
                    {path: "smetaAccNew", element: <SmetaAccNew/>, handle: {titleKey: "smetaAccNew"}},
                    {path: "contractTab", element: <ContractTab/>, handle: {titleKey: "contractTab"}},
                    {path: "contractOldTab", element: <ContractOldTab/>, handle: {titleKey: "contractOldTab"}},
                    {path: "contractAdd", element: <ContractAdd/>},
                    {path: "contractTab/edit/:id", element: <ContractEdit/>},
                    {path: "cashAppTab", element: <CashAppTab/>, handle: {titleKey: "cashAppTab"}},
                    {path: "cashAppAdd", element: <CashAppAdd/>},
                    {path: "cashAppTab/edit/:id", element: <CashAppEdit/>},
                    {path: "vendorAdd", element: <VendorAdd/>},
                    {path: "vendorTab", element: <VendorTab/>, handle: {titleKey: "vendorTab"}},
                    {path: "vendorTab/edit/:id", element: <VendorEdit/>},
                    {path: "invoiceAdd", element: <InvoiceAdd/>, handle: {titleKey: "invoiceAdd"}},
                    {path: "invoiceTab", element: <InvoiceTab/>, handle: {titleKey: "invoiceTab"}},
                    {path: "invoiceEdit", element: <InvoiceEdit/>, handle: {titleKey: "invoiceEdit"}},
                    {path: "didox/addInvoice/:id/:source", element: <InvoiceEdit/>},
                    {path: "AccessRole", element: <AccessRole/>},
                    {path: "AccessDocAction", element: <AccessDocAction/>},
                    //{path: "citizenHistory", element: <CitizenHistory/>, handle: {titleKey: "citizenHistory"}},
                    {path: "accountStateTab", element: <AccountStateTab/>, handle: {titleKey: "accountStateTab"}},
                    {path: "accSaldoPeriodTab", element: <AccSaldoPeriodTab/>, handle: {titleKey: "accSaldoPeriodTab"}},
                    {path: "accountMonitoringTab", element: <AccountMonitoringTab/>, handle: {titleKey: "accountMonitoringTab"}},
                    {path: "smetaExecuteTab", element: <SmetaExecuteTab/>, handle: {titleKey: "smetaExecuteTab"}},
                    {path: "tradeExchangeDocsTab", element: <TradeExchangeDocumentsTab/>, handle: {titleKey: "tradeExchangeDocsTab"}},

                    {path: "contractExecuteTab", element: <ContractExecuteTab/>, handle: {titleKey: "contractExecuteTab"}},
                    {path: "cashAppExecuteTab", element: <CashAppExecuteTab/>, handle: {titleKey: "cashAppExecuteTab"}},
                    {path: "documentControlsTab", element: <DocumentControlsTab/>, handle: {titleKey: "documentControlsTab"}},
                    {path: "didoxProductsTab", element: <DidoxProductsTab/>, handle: {titleKey: "didoxProductsTab"}},
                    {path: "procurementTab", element: <ProcurementTab/>, handle: {titleKey: "procurementTab"}},
                    {path: "procurementAdd", element: <ProcurementAdd/>, handle: {titleKey: "procurementAdd"}},
                    {path: "procurementCreate", element: <ProcurementCreate/>, handle: {titleKey: "procurementCreate"}},
                    {path: "inmatesTab", element: <InmatesTab/>, handle: {titleKey: "inmatesTab"}},
                    {path: "inmatesSaldoTab", element: <InmatesSaldoTab/>, handle: {titleKey: "inmatesSaldoTab"}},
                    {path: "didoxInvoiceView", element: <DidoxInvoice/>, handle: {titleKey: "didoxInvoiceView"}},
                    {path: "didoxUsersTab", element: <DidoxUsersTab/>, handle: {titleKey: "didoxUsersTab"}},
                    {path: "didox/addContract/:id/:source", element: <ContractEdit/>},
                    {path: "munisPay", element: <MunisPay/>, handle: {titleKey: "munisPay"}},
                    {path: "TEST", element: <TEST/>, handle: {titleKey: "TEST"}},
                    {path: "*", element: <NotFoundNew/>, handle: {titleKey: "NotFound"}}
                ]
            }
        ]
    },
    { path: "*", element: <NotFoundNew /> }
]);
